<sw-page class="topdata-reg-attempt-log-list">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataContactLoginSW6.regLog.list.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="danger" @click="onClear">
            {{ $tc('TopdataContactLoginSW6.regLog.list.buttonClear') }}
        </sw-button>
        <sw-button variant="primary" @click="onDownloadCsv">
            {{ $tc('TopdataContactLoginSW6.regLog.list.buttonDownloadCsv') }}
        </sw-button>
        <sw-button variant="primary" @click="getList">
            {{ $tc('global.default.refresh') }}
        </sw-button>
    </template>

    <template #content>
        <div class="topdata-reg-attempt-log-list__toolbar">
            <sw-text-field
                v-model="emailSearchTerm"
                class="topdata-reg-attempt-log-list__search"
                size="small"
                :placeholder="$tc('TopdataContactLoginSW6.regLog.list.searchEmailPlaceholder')"
                @input="onEmailSearchInput"
            >
                <template #prefix>
                    <sw-icon name="regular-search" size="16" />
                </template>
            </sw-text-field>
        </div>

        <sw-entity-listing
            v-if="items"
            :items="items"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            detail-route="topdata.contact.login.reg.log.detail"
            identifier="id"
            @page-change="onPageChange"
        >
            <template #column-attemptType="{ item }">
                <sw-badge variant="info">
                    {{ getAttemptTypeLabel(item.attemptType) }}
                </sw-badge>
            </template>

            <template #column-conflictType="{ item }">
                <sw-badge :variant="getConflictTypeVariant(item.conflictType)">
                    {{ getConflictTypeLabel(item.conflictType) }}
                </sw-badge>
            </template>

            <template #column-createdAt="{ item }">
                {# {{ formatDate(item.createdAt) }} / #}
                <sw-time-ago
                    :date="item.createdAt"
                    :date-time-format="{ month: '2-digit', day: '2-digit' }"
                />
            </template>
        </sw-entity-listing>

        <sw-modal
            v-if="showClearModal"
            :title="$tc('TopdataContactLoginSW6.regLog.list.clearModalTitle')"
            variant="small"
            @modal-close="onCancelClear"
        >
            <p>{{ $tc('TopdataContactLoginSW6.regLog.list.clearModalBody') }}</p>

            <template #modal-footer>
                <sw-button size="small" @click="onCancelClear">
                    {{ $tc('global.default.cancel') }}
                </sw-button>
                <sw-button variant="danger" size="small" @click="onConfirmClear">
                    {{ $tc('TopdataContactLoginSW6.regLog.list.clearModalConfirm') }}
                </sw-button>
            </template>
        </sw-modal>
    </template>
</sw-page>
